import * as React from 'react';

import { bemElement } from 'af-utils/bem.util';

interface OwnProps {
	isSelected: boolean;
	onSelect: (tabId: number) => void;
	tabId: number;
	title: string;
}

type Props = OwnProps;

const Tab: React.FC<Props> = (props: Props) => {
	const { tabId, onSelect, isSelected, title } = props;

	const select = React.useCallback(() => onSelect(tabId), [tabId, onSelect]);

	const tabClassName = bemElement('schedule-board-labor-modal', 'tab', { active: isSelected });

	return (
		<div className={tabClassName} onClick={select}>
			{title}
		</div>
	);
};

export default React.memo(Tab);
